import React from 'react';
import PropTypes from 'prop-types';
import {
  isNonEmptyString,
  isNumeric,
  createCustomPropType,
} from '../../../../js/app/react/validators';

const BackView = ({
  workflowId,
  clientId,
  onBack,
  validationId,
  isBusy,
  hide,
  backText,
  browserBackInsteadOfWorkflowBack,
  onBrowserBack,
}) =>
  !hide && (
    <div className="adv-workflow-navigation-back">
      <button
        className="adv-workflow-navigation-back-button"
        type="button"
        disabled={isBusy}
        onClick={
          browserBackInsteadOfWorkflowBack
            ? onBrowserBack
            : onBack(validationId, clientId, workflowId)
        }
      >
        <i className="adv-workflow-navigation-back-button-i fa fa-caret-left" />
        {backText}
      </button>
    </div>
  );

BackView.defaultProps = {
  hide: false,
  backText: 'Previous Step',
};

BackView.propTypes = {
  backText: PropTypes.string,
  hide: PropTypes.bool,
  isBusy: PropTypes.bool.isRequired,
  onBack: PropTypes.func.isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  validationId: createCustomPropType(isNonEmptyString).isRequired,
};

export default BackView;
